import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated, watch } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import ApprovalHistoryService from "@/services/MenuApprovalHistoryDataService";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const isNoData = ref(false);
const isSearch = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref(store.getters.showPageTitle);
const distAdminListInfo = reactive([]);
const getData = ref(false);

const mainMenuList = reactive([]);
const stationList = reactive([]);
const inputUserId = ref("");
const selectedMenu = ref("");
const selectedStation = ref("");
const selectedMode = ref("1");
const pageCount = ref(1);
const pageRowCount = ref(20);
const currentPageNo = ref(1);
const historyBackBtnText = ref("<< Back");
const historyNextBtnText = ref("Next >>");
const allApprovalHistoryList = reactive([]);
const approvalHistoryList = reactive([]);
const revertApprovalData = reactive([]);

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  if(store.getters.stationListData != null){
    stationList.splice(0);
    stationList.push(store.getters.stationListData);
    selectedStation.value = stationList[0][0].stationCode;
  }
  getMainMenuList();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tblMenuHistoryBody")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("divMenuHistoryBody")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("divMenuHistoryBody").style.width = "100%";
      } else {
        document.getElementById("divMenuHistoryBody").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

watch(
  () => [store.getters.stationListData],
  function () {
    if(store.getters.stationListData != null){
      stationList.splice(0);
      stationList.push(store.getters.stationListData);
      selectedStation.value = stationList[0][0].stationCode;
    }
  }
);
const getMainMenuList = () => {
  isLoading.value = true;
  mainMenuList.splice(0);
  ApprovalHistoryService.getAllMainMenuInfo().then((resMenuList: ResponseData) => {
    mainMenuList.push(resMenuList.data);
    selectedMenu.value = mainMenuList[0][0].mainMenuCode;
    isLoading.value = false;
  })
  .catch((e: Error) => {
      console.log(e);
      isLoading.value = false;
  });
};

const goSearchApprovalHistory = () => {
  getMenuApprovalHistory();
}

/** 権限承認ログリスト取得 */
const getMenuApprovalHistory = () => {
  isLoading.value = true;
  isNoData.value = false;
  isSearch.value = true;
  distAdminListInfo.splice(0);

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  var data = {
    userId: inputUserId.value,
    menuCode: selectedMenu.value,
    stationCode: selectedStation.value,
    searchMode: selectedMode.value,
    loginUserId: store.getters.cognitoUserName
  }
  approvalHistoryList.splice(0);
  allApprovalHistoryList.splice(0);
  ApprovalHistoryService.getMenuApprovalHistory(data).then((resHistory: ResponseData) => {
    if (resHistory.data.length != 0) {
      pageCount.value = resHistory.data[0].length == 0? 1: Math.ceil(resHistory.data[0].length / pageRowCount.value);
      isNoData.value = resHistory.data[0].length == 0? true: false;
      currentPageNo.value = 1;
      allApprovalHistoryList.push(resHistory.data[0]);
      var startIdx = 0;
      for (let obj of allApprovalHistoryList[0]) {
        if (startIdx < pageRowCount.value) {
          const date = new Date(Date.parse(obj.processDate));
          obj.processDate = date.toLocaleString("en-US", { hour12: false });
          approvalHistoryList.push(obj);
          startIdx++;
        } else {
          break;
        }
      }
    } else {
      pageCount.value = 1;
      currentPageNo.value = 1;
      isNoData.value = true;
    }
    isLoading.value = false;
  });
}

const rdoCheckChange = (event: { target: { value: any; }; }) => {
  selectedMode.value = event.target.value;
}

const changeHistoryPage = (direction: string) => {
  approvalHistoryList.splice(0);
  var startIndex = 0;
  var endIndex = 0;
  if (direction == "Next") {
    startIndex = currentPageNo.value * pageRowCount.value;
    endIndex = (currentPageNo.value * pageRowCount.value) + pageRowCount.value;
    if (endIndex >= allApprovalHistoryList[0].length) {
        endIndex = allApprovalHistoryList[0].length;
    }
    currentPageNo.value = currentPageNo.value + 1;
  } else {
    startIndex = ((currentPageNo.value - 1) * pageRowCount.value) - pageRowCount.value;
    endIndex = (currentPageNo.value * pageRowCount.value) - pageRowCount.value;
    currentPageNo.value = currentPageNo.value - 1;
  }
  for (var i = startIndex; i < endIndex; i++) {
    const date = new Date(Date.parse(allApprovalHistoryList[0][i].processDate));
    allApprovalHistoryList[0][i].processDate = date.toLocaleString("en-US", { hour12: false });
    approvalHistoryList.push(allApprovalHistoryList[0][i]);
  }
}

const showRevertApprovalModal = (historyObj: any) => {
  revertApprovalData.splice(0);
  revertApprovalData.push(historyObj.userId_id);
  revertApprovalData.push(historyObj.mainMenuCode);
  revertApprovalData.push(historyObj.stationCode);
  revertApprovalData.push(store.getters.cognitoUserName);
}

const cancelApprovalStatus = () => {
  isLoading.value = true;
  var data = {
    userId: revertApprovalData[0],
    menuCode: revertApprovalData[1],
    stationCode: revertApprovalData[2],
    loginUserId: revertApprovalData[3]
  }
  ApprovalHistoryService.revertApprovalStatus(data).then((resData: ResponseData) => {
    getMenuApprovalHistory();
    alertMessage.value = i18n.t("suc038");
    alertState.value = "success";
  })
  .catch((e: Error) => {
    console.log(e.message);
    if(e.response.status == 404){
      alertMessage.value = e.message;
    }else{
      alertMessage.value = i18n.t("err074");
    }    
    alertState.value = "error";
    isLoading.value = false;
  });
}
onUpdated(function () {
  handleResize();
});


const __returned__ = { isLoading, isNoData, isSearch, alertMessage, alertState, i18n, title, distAdminListInfo, getData, mainMenuList, stationList, inputUserId, selectedMenu, selectedStation, selectedMode, pageCount, pageRowCount, currentPageNo, historyBackBtnText, historyNextBtnText, allApprovalHistoryList, approvalHistoryList, revertApprovalData, handleResize, getMainMenuList, goSearchApprovalHistory, getMenuApprovalHistory, rdoCheckChange, changeHistoryPage, showRevertApprovalModal, cancelApprovalStatus, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})